module.exports = __webpack_public_path__ + "static/media/academia_03.2ee748d6.jpg";